import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/common.json';

export const defaultNS = 'common';
export const resources = {
  en: { common: en },
} as const;

export async function initI18n(): Promise<typeof i18n> {
  if (i18n.isInitialized) return i18n;
  await i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: 'en',
      defaultNS,
      ns: [defaultNS],
      interpolation: { escapeValue: false },
      returnNull: false,
      detection: {
        order: ['querystring', 'navigator'],
        caches: [],
      },
    });
  return i18n;
}

export default i18n;
